module.exports = (__parcel__import__("8WVzQ")).then(() => parcelRequire('ieIpp'));